import { render, staticRenderFns } from "./ScanCard.vue?vue&type=template&id=042507b0&scoped=true&"
import script from "./ScanCard.vue?vue&type=script&lang=ts&"
export * from "./ScanCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScanCard.vue?vue&type=style&index=0&id=042507b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042507b0",
  null
  
)

export default component.exports